module.exports = __webpack_public_path__ + "img/item_bookCover_01.ff303b79.jpeg";